import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async () => {
  const { data } = await api.get("/products");
  return data;
};

export const fetchProduct = async (idOrSlug) => {
  const { data } = await api.get(`/products/${idOrSlug}`);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await api.post("/orders", payload);
  return data;
};

export const createCheckoutSession = async ({ order_id, origin_url }) => {
  const { data } = await api.post("/checkout/session", { order_id, origin_url });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};
